import { createSelector } from "reselect";
// import { getFormValues } from 'redux-form';
import { mapFilter, sortByKey, isObject } from "utils/helpers";

/**
 * Direct selector to the channelsPage state domain
 */
const selectChannelsPageDomain = () => (state) => state.channels;

/**
 * Other specific selectors
 */

const selectAllChannels = () =>
  createSelector(
    selectChannelsPageDomain(),
    (substate) => substate.allChannels
  );

const selectChannelThemes = () =>
  createSelector(selectChannelsPageDomain(), (substate) =>
    sortByKey(substate.channelThemes)
  );

const selectModes = () =>
  createSelector(selectChannelsPageDomain(), (substate) =>
    sortByKey(substate.modes)
  );

const selectClientFilter = () =>
  createSelector(
    selectChannelsPageDomain(),
    (substate) => substate.clientFilter
  );

const selectStatusFilter = () =>
  createSelector(
    selectChannelsPageDomain(),
    (substate) => substate.statusFilter
  );

const selectIsFetching = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.isFetching);

// Whether the channel list request has SETTLED — succeeded or failed — as
// opposed to `isFetching`, which is only true while one is in flight. The two
// differ exactly once, and it is the case that matters: before the first
// request is dispatched both `isFetching` and `allChannels` are empty, which
// is indistinguishable from "the server said you have no channels".
const selectIsLoaded = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.loaded);

// Why the LIST fetch failed, as opposed to `selectChannelErrors` — which also
// carries save failures and is what Forms/index.js toasts on. Only this one may
// decide what the list renders. See the reducer.
const selectListError = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.listError);

const selectClients = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.clients);

const selectCurrentTab = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.currentTab);

const selectChannelSlugIsValid = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.validSlug);

const selectSlugIsValidating = () =>
  createSelector(
    selectChannelsPageDomain(),
    (substate) => substate.slugIsValidating
  );

const selectChannelThemeInstances = () =>
  createSelector(
    selectChannelsPageDomain(),
    (substate) => substate.channelThemeInstances
  );

/**
 * Default selector used by ChannelsPage
 */

const selectChannels = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate);

const selectPermissionRole = () => (state) => state.app.user.permission_role;

const selectSlugCheckFailed = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.slugCheckFailed);

const selectIsSaving = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.isSaving);

const selectSaveError = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.saveError);

const selectModesError = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.modesError);

const selectChannelErrors = () =>
  createSelector(selectChannelsPageDomain(), (substate) => substate.errors);
export default selectChannels;
export {
  selectChannelsPageDomain,
  selectClientFilter,
  selectStatusFilter,
  selectIsFetching,
  selectIsLoaded,
  selectListError,
  selectClients,
  selectSlugIsValidating,
  selectCurrentTab,
  selectAllChannels,
  selectChannelThemes,
  selectModes,
  selectChannelSlugIsValid,
  selectChannelThemeInstances,
  selectPermissionRole,
  selectChannelErrors,
  selectSlugCheckFailed,
  selectSaveError,
  selectIsSaving,
  selectModesError,
};
